import { Box } from "@chakra-ui/react";
import { FC } from "react";

export const Main: FC<{ maxWidth?: string }> = ({
  children,
  maxWidth = "760px",
}) => (
  <Box
    as="main"
    id="main-content"
    tabIndex={-1}
    outline="none"
    flex={`0 1 ${maxWidth}`}
    minW={0}
    maxWidth={maxWidth}
  >
    {children}
  </Box>
);
